import { DeleteOutlined, UploadOutlined } from '@ant-design/icons'
import { useEffect, useMemo, useRef, useState } from 'react'
import { Button, Input, message } from 'antd'
import PSAIModal from '@PSAIComponents/PSAIModal'
import Utils from '@utils/utils'
import { UPLOAD_SOURCE } from '@utils/CONST'
import styles from './index.module.scss'

const MaterialEditModal = ({ open, onCancel, item, onGenerate, generating }) => {
    const [desc, setDesc] = useState('')
    const [uploadLoading, setUploadLoading] = useState(false)
    const [referImage, setReferImage] = useState('')
    const fileInputRef = useRef(null)

    useEffect(() => {
        if (!open) return
        setDesc('')
        setReferImage('')
    }, [open, item?.taskId])

    const beanCost = useMemo(() => {
        const mode = String(item?.mode || item?.attr?.mode || '').toUpperCase()
        if (mode === '4K') return 120
        return 80
    }, [item])

    const targetImage = useMemo(() => {
        return item?.results?.[0]?.hdImage || item?.results?.[0]?.image || ''
    }, [item])

    const triggerUpload = () => {
        if (uploadLoading) return
        fileInputRef.current?.click()
    }

    const handleRemoveReferImage = (e) => {
        e.stopPropagation()
        if (uploadLoading) return
        setReferImage('')
    }

    const handleUploadFile = async (e) => {
        const file = e.target.files?.[0]
        e.target.value = ''
        if (!file) return
        try {
            setUploadLoading(true)
            const valid = await Utils.validateImageFile(file)
            if (!valid) return

            const resizeRes = await Utils.resizeImageFileMaxByAliyunBy(file, 4096)
            if (!resizeRes?.success) throw new Error(resizeRes?.message || '图片处理失败')

            const legalRes = await Utils.checkImageIslegal(resizeRes.file, 0, UPLOAD_SOURCE.SERVICE)
            if (!legalRes) return
            if (!legalRes.isLegal) {
                message.warning('图片违规，请重新上传')
                return
            }
            setReferImage(legalRes.data)
        } catch (err) {
            message.warning(err?.message || '上传失败')
        } finally {
            setUploadLoading(false)
        }
    }

    return (
        <PSAIModal
            open={open}
            onCancel={onCancel}
            footer={null}
            maxWidth={554}
            title="编辑图片"
            destroyOnClose
            className={styles.MaterialEditModal}
        >
            <div className={styles.Body}>
                <div className={styles.Content}>
                    <div className={styles.LeftWrap}>
                        <p className={styles.Title}>待修改图片</p>
                        <div className={styles.TargetImageBox}>
                            {!!targetImage && <img src={Utils.getImgThumbnail(targetImage)} alt="" />}
                        </div>
                    </div>
                    <div className={styles.RightWrap}>
                        <p className={styles.Title}>修改描述(必填)</p>
                        <Input.TextArea
                            className={styles.Textarea}
                            value={desc}
                            onChange={(e) => setDesc(e.target.value)}
                            autoSize={false}
                            style={{ height: 146 }}
                            placeholder={'请描述需要修改的内容，例如：\n• 把背景换成咖啡店\n• 把模特换成亚洲女性\n• 增加促销文案“限时折扣”'}
                            maxLength={200}
                        />
                        <p className={styles.Title} style={{ marginTop: 20 }}>参考图(可选，最多1张)</p>
                        <div className={styles.UploadBox} onClick={triggerUpload}>
                            {referImage ? <>
                                <img src={Utils.getImgThumbnail(referImage)} alt="" />
                                <div className={styles.UploadMask}>
                                    <span className={styles.ActionIcon} onClick={handleRemoveReferImage}>
                                        <DeleteOutlined />
                                    </span>
                                    <span className={styles.ActionDivider}></span>
                                    <span className={styles.ActionIcon} onClick={(e) => {
                                        e.stopPropagation()
                                        triggerUpload()
                                    }}>
                                        <UploadOutlined />
                                    </span>
                                </div>
                            </> : <span className={styles.Plus}>+</span>}
                        </div>
                        <input
                            ref={fileInputRef}
                            className={styles.HiddenInput}
                            type="file"
                            accept="image/*"
                            onChange={handleUploadFile}
                        />
                    </div>
                </div>
                <div className={styles.Footer}>
                    <Button className={styles.CancelBtn} onClick={onCancel}>取消</Button>
                    <Button
                        type="primary"
                        className={styles.GenerateBtn}
                        disabled={!desc.trim()}
                        loading={generating}
                        onClick={() => onGenerate?.({ desc: desc.trim(), referImage, item })}
                    >
                        生成
                        <img src={require('@assets/images/arcbean3.png')} alt="" />
                        {beanCost}
                    </Button>
                </div>
            </div>
        </PSAIModal>
    )
}

export default MaterialEditModal
